import { useMemo } from "react";
import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { Ico } from "../../../components/icons/icons.jsx";
import { ModalShellHeader } from "../../../components/modal/ModalShellHeader.jsx";
import { buildModalShellTokens } from "../../../components/modal/modalShellTheme.js";
import { COMMAND_TYPES } from "../commandUtils.js";

const TYPE_ICONS = {
  chip: Ico.chip,
  device: Ico.device,
  terminal: Ico.terminal,
};

export function CommandTypeSelectModal({ open, onClose, onSelect }) {
  const { c, dark, accentHex: A } = useThemeSlice();
  const ap = useMemo(() => buildModalShellTokens(dark, c, A), [dark, c, A]);

  if (!open) return null;

  return (
    <>
      <div
        role="presentation"
        onClick={onClose}
        style={{ position: "fixed", inset: 0, zIndex: 70, background: ap.overlay, backdropFilter: "blur(8px)" }}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="command-type-modal-title"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "min(560px, calc(100vw - 32px))",
          display: "flex",
          flexDirection: "column",
          background: ap.cardGradient,
          border: `1px solid ${ap.cardBorder}`,
          borderRadius: 16,
          zIndex: 71,
          boxShadow: ap.cardShadowLg,
          overflow: "hidden",
        }}
      >
        <ModalShellHeader
          title="Add command"
          titleId="command-type-modal-title"
          subtitle="Choose the type of command you want to create."
          icon={Ico.commands}
          onClose={onClose}
          closeLabel="Close command type picker"
          dark={dark}
          c={c}
          A={A}
          ap={ap}
        />

        <div style={{ padding: "20px 24px 24px", display: "flex", flexDirection: "column", gap: 10 }}>
          {COMMAND_TYPES.map((type) => (
            <button
              key={type.id}
              type="button"
              onClick={() => onSelect(type.id)}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
                gap: 14,
                textAlign: "left",
                padding: "16px 18px",
                borderRadius: 12,
                border: `1px solid ${c.cardBdr}`,
                background: dark ? "rgba(255,255,255,0.02)" : c.card,
                color: c.text,
                cursor: "pointer",
                fontFamily: "inherit",
                transition: "border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = `${A}55`;
                e.currentTarget.style.background = dark ? `${A}10` : `${A}06`;
                e.currentTarget.style.boxShadow = `0 0 0 1px ${A}22`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = c.cardBdr;
                e.currentTarget.style.background = dark ? "rgba(255,255,255,0.02)" : c.card;
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <span
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: A,
                  background: `${A}14`,
                  border: `1px solid ${A}28`,
                }}
              >
                {TYPE_ICONS[type.icon] ?? Ico.commands}
              </span>
              <span style={{ minWidth: 0 }}>
                <span style={{ display: "block", fontSize: 14, fontWeight: 700, color: c.text, marginBottom: 4 }}>
                  {type.label}
                </span>
                <span style={{ display: "block", fontSize: 12, color: c.sub, lineHeight: 1.45 }}>
                  {type.description}
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
